import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUsers,
    faCubes,
    faBasketShopping,
    faTruckLoading,
} from '@fortawesome/free-solid-svg-icons';

interface CounterProps {
    clients: number;
    productsSold: number;
    pendingOrders: number;
    importedOrders: number;
}

const DashboardCounters: React.FC<CounterProps> = ({
                                                       clients,
                                                       productsSold,
                                                       pendingOrders,
                                                       importedOrders,
                                                   }) => {
    const cardData = [
        {
            value: clients,
            label: "Clientes",
            icon: faUsers,
            iconColor: "#0d6efd",
            bgColor: "bg-info",
        },
        {
            value: productsSold,
            label: "Vendidos",
            icon: faCubes,
            iconColor: "#198754",
            bgColor: "bg-success",
        },
        {
            value: pendingOrders,
            label: "Pendentes",
            icon: faBasketShopping,
            iconColor: "#3490dc",
            bgColor: "#3490dc",
        },
        {
            value: importedOrders,
            label: "Importados",
            icon: faTruckLoading,
            iconColor: "#6c757d",
            bgColor: "bg-secondary",
        },
    ];

    return (
        <div className="my-3 container ">
            <Row className="gx-3 gy-3">
                {cardData.map((data, index) => (
                    <Col xs={6} sm={6} md={3} key={index} className="d-flex align-items-center">
                        <div className="info-box d-flex align-items-center  gap-3 w-100 border rounded shadow-sm p-1 overflow-hidden">
                            <span
                                className={`info-box-icon ${data.bgColor} elevation-1 d-flex align-items-center justify-content-center`}
                                style={{
                                    backgroundColor: data.iconColor,
                                    height: "50px",
                                    width: "50px",
                                    borderRadius: "8px",
                                }}
                            >
                                <FontAwesomeIcon icon={data.icon} color="white" size="lg" />
                            </span>
                            <div className="info-box-content d-flex flex-column">
                                <span className="info-box-text">{data.label}</span>
                                <span className="info-box-number">
                                    {data.value}
                                    <small>+</small>
                                </span>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default DashboardCounters;
